import { ScrollArea } from "@/components/ui/scroll-area"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

import RegionBalanceRow from "./RegionBalanceRow"

import type { BalanceRegion } from "../types/balanceMapTypes"

interface RegionBalanceTableProps {
  regions: BalanceRegion[]
  hoveredRegionId?: number | null
  onRegionHoverChange?: (regionId: number | null) => void
}

export default function RegionBalanceTable({
  regions,
  hoveredRegionId = null,
  onRegionHoverChange,
}: RegionBalanceTableProps) {
  return (
    <ScrollArea className="h-full">
      <Table className="table-fixed">
        <colgroup>
          <col className="w-[24%]" />
          <col className="w-[19%]" />
          <col className="w-[19%]" />
          <col className="w-[19%]" />
          <col className="w-[19%]" />
        </colgroup>
        <TableHeader className="bg-card-header border-b">
          <TableRow>
            <TableHead className="sticky top-0 z-20 px-4 py-2 font-semibold align-bottom bg-card-header-light">
              Region
            </TableHead>
            <TableHead
              colSpan={2}
              className="sticky top-0 z-20 text-center px-4 py-2 bg-card-header-light font-semibold"
            >
              Today
            </TableHead>
            <TableHead
              colSpan={2}
              className="sticky top-0 z-20 text-center px-4 py-2 bg-card-header-light font-semibold"
            >
              Tomorrow
            </TableHead>
          </TableRow>
          <TableRow>
            <TableHead className="sticky top-10 z-10 text-right px-4 py-2 font-medium bg-card-header"></TableHead>
            <TableHead className="sticky top-10 z-10 text-right px-4 py-2 font-medium bg-card-header">
              Trips In
            </TableHead>
            <TableHead className="sticky top-10 z-10 text-right px-4 py-2 font-medium bg-card-header">
              Trips Out
            </TableHead>
            <TableHead className="sticky top-10 z-10 text-right px-4 py-2 font-medium bg-card-header">
              Trips In
            </TableHead>
            <TableHead className="sticky top-10 z-10 text-right px-4 py-2 font-medium bg-card-header">
              Trips Out
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {regions.map((region) => {
            return (
              <RegionBalanceRow
                region={region}
                hoveredRegionId={hoveredRegionId}
                onRegionHoverChange={onRegionHoverChange}
              />
            )
          })}
          <TableRow aria-hidden className="h-full hover:bg-transparent">
            <TableCell className="p-0" />
            <TableCell className="p-0" />
            <TableCell className="p-0" />
            <TableCell className="p-0 bg-muted/50" />
            <TableCell className="p-0 bg-muted/50" />
          </TableRow>
        </TableBody>
      </Table>
    </ScrollArea>
  )
}
